import { ACCESS_STORAGE_KEYS, getStoredValue } from "@lib/access/access";
import { createCall, type ScopeContextBinding, spellbook } from "@sdk/spellbook";
import { createScopeQueryOptions } from "@sdk/tanstack";

import { setScopeInsiderCapability } from "./scopeContext";

const getUserInfoEndpoint = spellbook("/v1/users/me").GET();

export type GetUserInfoResponse = typeof getUserInfoEndpoint.types.Res;

// Preserve the user-detail cache key and record isInsider for scope checks;
// the endpoint and response type remain generated from spellbook.
export function getUserInfoQueryOptions() {
    return createScopeQueryOptions({
        operation: getUserInfoEndpoint,
        queryKey: ["user", "detail"],
        queryFn: ({ signal }, expectedScope) => getUserInfo(expectedScope, signal),
        options: { staleTime: 1000 * 60 * 60 * 24 },
    });
}

export async function getUserInfo(
    expectedScope?: ScopeContextBinding,
    signal?: AbortSignal,
): Promise<GetUserInfoResponse> {
    const principalId = getStoredValue(ACCESS_STORAGE_KEYS.userId);
    const call = createCall(getUserInfoEndpoint, undefined, { expectedScope });
    const user = await call({ signal });
    setScopeInsiderCapability(principalId, user.isInsider);
    return user;
}
